import styled from 'styled-components'

export const Wrap = styled.div`
  position: relative;
`
export const Pagination = styled.div<{ $variant: 'default' | 'compact' }>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  gap: 40px;
  ${({ $variant }) => $variant === 'compact' && `
    flex-direction: column;
    gap: 24px;
  `};
  @media screen and (max-width: ${({ theme }) => theme.resolution.xxl}) {
    flex-direction: column;
    gap: 24px;
  }
  @media screen and (max-width: ${({ theme }) => theme.resolution.sm}) {
    max-width: 100%;
    ul {
      margin: 0;
      flex-wrap: nowrap;
      justify-content: center;
    }
  }
`
export const Paginator = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  flex-wrap: nowrap;
  @media screen and (max-width: ${({ theme }) => theme.resolution.sm}) {
    gap: 0;
  }
`
export const Item = styled.span<{ $active: boolean }>`
  border: 1px solid !important;
  border-color: ${(props) => props.$active ? props.theme.color.dodgerblue : props.theme.color.linkwater} !important;
  border-radius: 8px !important;
  min-width: 38px !important;
  height: 38px !important;
  font-family: 'e-Ukraine' !important;
  line-height: 38px !important;
  margin: 0 4px !important;
  transition: all 0s !important;
  background-color: ${(props) => props.$active ? props.theme.color.dodgerblue : 'transparent'} !important;
  color: ${(props) => props.$active ? props.theme.color.white : props.theme.color.black} !important;
  &:hover {
    padding: 0 6px;
    border: ${props => props.$active ? 'none' : 'double 1px transparent'} !important;
    background-image: ${props => props.$active
      ? `linear-gradient(329.85deg, ${props.theme.color.goldenyellow} 6.75%, ${props.theme.color.dodgerblue} 91.35%)`
      : `linear-gradient(${props.theme.color.white}, ${props.theme.color.white}),
      radial-gradient(circle at bottom right, ${props.theme.color.goldenyellow}, ${props.theme.color.dodgerblue}) `
    } !important;
    background-origin: border-box;
    background-clip: padding-box, border-box;
    color: ${(props) => props.$active ? props.theme.color.white : props.theme.color.black} !important;
  }
`
export const ShowMore = styled.div<{ $variant: 'default' | 'compact' }>`
  position: absolute;
  left: 0;
  border: 1px solid ${({ theme }) => theme.color.dodgerblue};
  border-radius: 42px;
  ${({ theme }) => theme.typography.p1};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: ${({ theme }) => theme.color.dodgerblue};
  cursor: pointer;
  &:hover {
    height: 44px;
    padding: 0;
    border: double 1px transparent;
    background-image:
      linear-gradient(${({ theme }) => theme.color.whitesmoke}, ${({ theme }) => theme.color.whitesmoke}),
      radial-gradient(circle at bottom right, ${({ theme }) => theme.color.goldenyellow}, ${({ theme }) => theme.color.dodgerblue});
    background-origin: border-box;
    background-clip: content-box, border-box;
  }
  & > span {
    color: ${({ theme }) => theme.color.dodgerblue};
    padding: 11px 40px;
    ${({ theme }) => theme.typography.p1};
  }
  ${({ $variant }) => $variant === 'compact' && `
    position: relative;
  `};
  @media screen and (max-width: ${({ theme }) => theme.resolution.xxl}) {
    position: relative;
  }
`
